export const imageModalHandler = (onModalOpen, onModalClose) => {
    console.debug('Image modal script loaded');
    let previouslyFocusedElement = null;
    const trapFocus = (modal) => {
        const focusableElements = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];
        modal.addEventListener('keydown', e => {
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                }
                else {
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            }
        });
    };
    const handleKeyDown = (e, modal) => {
        if (e.key === 'Escape') {
            closeModal(modal);
        }
    };
    const openModal = (modal, img, figcaption) => {
        previouslyFocusedElement = document.activeElement;
        const modalImage = modal.querySelector('img');
        const modalVideo = modal.querySelector('video');
        const caption = modal.querySelector('.spv-campaignPage__image-modal-caption');
        if (modalImage && !modalVideo) {
            modalImage.src = img.src;
            modalImage.alt = img.alt || 'Enlarged image';
        }
        onModalOpen();
        modal.style.display = 'block';
        modal.setAttribute('aria-hidden', 'false');
        document.body.setAttribute('aria-hidden', 'true');
        if (modalVideo) {
            modalVideo.load();
        }
        if (caption) {
            const modalContentOffsetLeft = document.querySelector('.spv-campaignPage__imageModalContent')
                ?.offsetLeft || 0;
            const imageOffsetLeft = modalImage?.offsetLeft || 0;
            caption.innerHTML = figcaption?.innerHTML || '';
            caption.style.marginLeft = imageOffsetLeft - modalContentOffsetLeft + 'px';
        }
        const closeButton = modal.querySelector('.spv-campaignPage__imageModalClose');
        if (closeButton) {
            closeButton.focus();
        }
        trapFocus(modal);
        const keyDownHandler = (e) => handleKeyDown(e, modal);
        document.addEventListener('keydown', keyDownHandler);
        modal.keyDownHandler = keyDownHandler;
    };
    const closeModal = (modal) => {
        onModalClose();
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
        document.body.removeAttribute('aria-hidden');
        const modalVideo = modal.querySelector('video');
        if (modalVideo) {
            modalVideo?.pause();
        }
        if (modal.keyDownHandler) {
            document.removeEventListener('keydown', modal.keyDownHandler);
            delete modal.keyDownHandler;
        }
        if (previouslyFocusedElement) {
            previouslyFocusedElement.focus();
        }
    };
    return window.addEventListener('DOMContentLoaded', () => {
        const imageModal = document.getElementById('spv-campaignPage__image-modal');
        const videoModal = document.getElementById('spv-campaignPage__video-modal');
        const allImages = document.querySelectorAll('figure');
        allImages.forEach(image => {
            if (image.classList.contains('spv-campaignPage__mediaItemBlock--centered') ||
                image.classList.contains('spv-campaignPage__mediaItemBlock--full'))
                return;
            const img = image.querySelector('img');
            const video = image.querySelector('video');
            const figcaption = image.querySelector('figcaption');
            const videoContainer = image.querySelector('[data-videocontainer]');
            if (!img && !video)
                return;
            if (img) {
                img.setAttribute('tabindex', '0');
                const handleClick = () => {
                    if (!imageModal)
                        return;
                    openModal(imageModal, img, figcaption);
                };
                img.addEventListener('click', handleClick);
                img.addEventListener('keydown', e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleClick();
                    }
                });
            }
            if (video && videoModal && videoContainer) {
                videoContainer.setAttribute('tabindex', '0');
                const handleVideoClick = () => {
                    const modalVideo = videoModal.querySelector('video source');
                    const modalSource = modalVideo?.querySelector('video source');
                    console.log('Source:', modalVideo);
                    if (modalVideo) {
                        const videoSource = video.querySelector('source');
                        if (videoSource) {
                            modalVideo.src = videoSource.src;
                        }
                    }
                    openModal(videoModal, video, figcaption);
                };
                videoContainer.addEventListener('click', handleVideoClick);
                videoContainer.addEventListener('keydown', e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleVideoClick();
                    }
                });
            }
        });
        [imageModal, videoModal].forEach(modal => {
            if (!modal)
                return;
            const closeButton = modal.querySelector('.spv-campaignPage__imageModalClose');
            if (closeButton) {
                closeButton.setAttribute('aria-label', 'Close modal');
                closeButton.addEventListener('click', () => closeModal(modal));
            }
            modal.addEventListener('click', event => {
                if (event.target === modal) {
                    closeModal(modal);
                }
            });
        });
    });
};
//# sourceMappingURL=image-modal.js.map